








































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ECriiptoStatus } from '@signing-page/signing/types/enums/criipto-status';
import type { IEId } from '@signing-page/signing/types/eid';
import { EEidType } from '@signing-page/signing/types/enums/eid-type';
import MitId from '@signing-page/signing/assets/mitid.svg';

@Component({
  components: {
    MitId,
  },
  data: () => ({
    ECriiptoStatus,
    EEidType,
  }),
})
export default class CriiptoButton extends Vue {
  @Prop() status!: ECriiptoStatus;
  @Prop() selectedEid!: IEId;

  get isDisabled(): boolean {
    return [ECriiptoStatus.Loading].includes(this.status);
  }

  handleClick(): void {
    this.$emit('sign');
  }
}
